import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loading: false,
        deletingId: null,
        pages: [],
        filter: {
            column: 'title',
            value: ''
        },
        currentPage: 1,
        pageSize: 20,
        total: 0,
        listError: '',
        flag: {
            type: '',
            text: ''
        }
    }
}

const getCriteria = (instance) => {
    const value = String(instance.state.filter.value || '').trim()
    if (!value) {
        return {}
    }

    const column = instance.state.filter.column || 'title'
    return {
        [column]: value
    }
}

const parsePageList = (responseData) => {
    const data = responseData && responseData.data ? responseData.data : {}
    const pages = data.pages || data.items || data.rows || []
    const total = Number(data.total || data.count || pages.length || 0)

    return {
        pages,
        total
    }
}

const loadPages = (instance) => {
    instance.setState({ ...instance.state, loading: true, listError: '' })

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/pages',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: getCriteria(instance)
        }
    }).then(response => handleLoadPagesResponse(instance, response))
    .catch(error => {
        instance.setState({
            ...instance.state,
            loading: false,
            listError: 'Failed to load pages. Please try again.'
        })

        alert(error)
    })
}

const handleLoadPagesResponse = (instance, response) => {
    if (response.status === 200 && response.data.status === 200) {
        const parsed = parsePageList(response.data)
        instance.setState({
            ...instance.state,
            loading: false,
            pages: parsed.pages,
            total: parsed.total,
            listError: ''
        })
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
    else {
        instance.setState({
            ...instance.state,
            loading: false,
            listError: response.data.message || 'Failed to load pages.'
        })
    }
}

const deletePage = (instance, id) => {
    instance.setState({ ...instance.state, deletingId: id })

    axios({
        method: 'post',
        url: API_ENDPOINT + '/api/content/page/delete',
        headers: {
            Authorization: store.getState().auth.authorizationToken
        },
        data: {
            id: id
        }
    }).then(response => handleDeletePageResponse(instance, response, id))
    .catch(error => {
        instance.setState({
            ...instance.state,
            deletingId: null,
            flag: {
                type: 'error',
                text: 'Delete failed. Please retry.'
            }
        })
        alert(error)
    })
}

const handleDeletePageResponse = (instance, response, id) => {
    if (response.status === 200 && response.data.status === 200) {
        instance.setState({
            ...instance.state,
            deletingId: null,
            flag: {
                type: 'success',
                text: 'Page deleted successfully.'
            }
        }, () => loadPages(instance))
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
    else {
        instance.setState({
            ...instance.state,
            deletingId: null,
            flag: {
                type: 'error',
                text: response.data.message || ('Delete failed for page ' + id)
            }
        })
    }
}

const PagesWorker = instance => {
    return {
        getDefaultState: () => getDefaultState(),
        loadPages: () => loadPages(instance),
        deletePage: (id) => deletePage(instance, id)
    }
}

export default PagesWorker
